import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import 'react-photoswipe/lib/photoswipe.css';
const PhotoSwipe = loadable(() => import('react-photoswipe'));
const PDPPinchToZoomGallery = t0 => {
  const $ = _c(32);
  const {
    isOpen: t1,
    isEditOrder: t2,
    photos: t3,
    selectedPhotoIndex,
    setSelectedPhotoIndex,
    onClose
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const photos = t4;
  let t5;
  if ($[2] !== photos) {
    t5 = photos.map(_temp);
    $[2] = photos;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const items = t5;
  let t6;
  if ($[4] !== selectedPhotoIndex) {
    t6 = {
      index: selectedPhotoIndex,
      history: false
    };
    $[4] = selectedPhotoIndex;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== photos || $[7] !== setSelectedPhotoIndex) {
    t7 = updatedData => {
      if (updatedData && updatedData.currItem) {
        const updatedSelectedIndex = photos.findIndex(photo => photo.src === updatedData.currItem.src);
        setSelectedPhotoIndex(updatedSelectedIndex);
      }
    };
    $[6] = photos;
    $[7] = setSelectedPhotoIndex;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isOpen || $[10] !== items || $[11] !== onClose || $[12] !== t6 || $[13] !== t7) {
    t8 = <PhotoSwipe className="PDPPinchToZoomGallery__PhotoSwipe z-[1] [&_img]:object-contain" isOpen={isOpen} items={items} options={t6} onClose={onClose} afterChange={t7} />;
    $[9] = isOpen;
    $[10] = items;
    $[11] = onClose;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = !isOpen;
  let t10;
  if ($[15] !== isOpen || $[16] !== t9) {
    t10 = classNames("z-[2000] fixed bottom-0 left-0 right-0 p-4 ", {
      hidden: t9,
      flex: isOpen
    });
    $[15] = isOpen;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = photos?.[selectedPhotoIndex]?.optionId;
  const t12 = photos?.[selectedPhotoIndex]?.valueId;
  const t13 = photos?.[selectedPhotoIndex]?.upholsteryName;
  let t14;
  if ($[18] !== onClose) {
    t14 = () => onClose(true);
    $[18] = onClose;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== isEditOrder || $[21] !== t11 || $[22] !== t12 || $[23] !== t13 || $[24] !== t14) {
    t15 = <PDPShownIn fullWidth={true} isEditOrder={isEditOrder} optionId={t11} valueId={t12} upholsteryName={t13} onSelection={t14} />;
    $[20] = isEditOrder;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t10 || $[27] !== t15) {
    t16 = <div className={t10}>{t15}</div>;
    $[26] = t10;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16 || $[30] !== t8) {
    t17 = <div className="PDPPinchToZoomGallery">{t8}{t16}</div>;
    $[29] = t16;
    $[30] = t8;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
};
PDPPinchToZoomGallery.propTypes = {
  isOpen: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  photos: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string
  })),
  selectedPhotoIndex: PropTypes.number,
  setSelectedPhotoIndex: PropTypes.func
};
export default PDPPinchToZoomGallery;
function _temp(t0) {
  const {
    src
  } = t0;
  return {
    src,
    w: 3000,
    h: 1500
  };
}